module.exports = __webpack_public_path__ + "static/media/about-2.a2f4dd56.jpg";